import { Modal } from "./ui/Modal";
import { SettingsPanel } from "./SettingsPanel";
import { useUiStore } from "../stores/uiStore";

export function SettingsModal() {
  const open = useUiStore((s) => s.settingsOpen);
  const setOpen = useUiStore((s) => s.setSettingsOpen);
  return (
    <Modal open={open} className="max-w-[620px]">
      <div>
        <SettingsPanel />
        <div className="flex justify-end border-t border-border px-5 py-4 dark:border-border-dark">
          <button className="text-sm font-medium text-muted hover:text-text dark:text-muted-dark" onClick={() => setOpen(false)}>閉じる</button>
        </div>
      </div>
    </Modal>
  );
}
